export default __webpack_public_path__ + "static/media/img1.0176cb08.jpg";